module.exports = __webpack_public_path__ + "media/7_1.65778e5e.wav";